<template lang="pug">
filter-detail-container(title="Filter Payment" :save-mode="false" @back="back" @clear="clear" @save="save")
  template(v-slot:body)
    .px-6.pt-6.pb-2.text-md Choose the payment status that you want to filter:
    div(v-for="status in statuses" :key="status.value")
      .d-flex.text-sm.pa-6.cursor-pointer.hover-bg(@click="clickItem(status.value)")
        yc-checkbox(v-model="selected" :value="status.value")
        .ml-4.font-medium {{ status.label }}
      v-divider.basic300
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  components: { FilterDetailContainer },
  data: () => ({
    isLoading: true,
    selected: [],
    statuses: [
      { value: 'true', label: 'Paid' },
      { value: 'false', label: 'Unpaid' },
      { value: 'NA', label: 'N/A' }
    ],
  }),
  created () {
    if (this.filter.items) {
      this.selected = this.filter.items
    }
  },
  methods: {
    save () {
      const filter = {}
      if (this.selected.length) {
        filter['items'] = this.selected
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back () {
      this.$emit('onBack')
    },
    clear () {
      this.selected = []
    },
    clickItem (value) {
      if (this.selected.includes(value)) {
        this.selected = this.selected.filter(x => x !== value)
      } else {
        this.selected.push(value)
      }
    }
  }
}
</script>